import React from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components';

import Label from 'components/Text/Label';

export const LabelCol = styled(Col)`
  padding: 1rem;
  font-weight: 500;
  text-align: right;
  @media (max-width: 768px) {
    text-align: left;
  }
`;
export const ContentCol = styled(Col)`
  padding: 1rem;
`;
export const InputPaddingWrapper = styled(Row)`
  &:not(:last-of-type) ${ContentCol} {
    border-bottom: 1px solid #e7e7e7;
  }
`;

const formatPrimitive = (value: any): string | number => {
  return typeof value === 'string' || typeof value === 'number' ? value : String(value);
};

const normalizeContent = (value: any): React.ReactNode => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'boolean' || typeof value === 'bigint') {
    return value.toString();
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return value;
  }

  if (React.isValidElement(value)) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((item, index) => (
      <React.Fragment key={index}>{normalizeContent(item)}</React.Fragment>
    ));
  }

  if (value instanceof Set) {
    return Array.from(value)
      .map(item => formatPrimitive(item))
      .join(', ');
  }

  if (value instanceof Map) {
    return Array.from(value.entries())
      .map(([key, val]) => `${String(key)}: ${formatPrimitive(val)}`)
      .join(', ');
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  if (
    typeof value === 'object' &&
    value !== null &&
    '_isAMomentObject' in value &&
    typeof (value as any).toISOString === 'function'
  ) {
    return (value as any).toISOString();
  }

  if (typeof value === 'object') {
    try {
      return JSON.stringify(value as Record<string, unknown>);
    } catch (error) {
      return String(value);
    }
  }

  return String(value);
};

const RenderInGrid = ({
  description,
  content,
  hasContentChanged
}: {
  description: string;
  content: any;
  hasContentChanged?: any;
}) => {
  const testLabel = description.replace(/\s/g, '_').replace(':', '').toLowerCase();
  const style = hasContentChanged ? { backgroundColor: '#FF7F00', margin: '2px 0' } : {};
  const displayContent = normalizeContent(content);

  return (
    <InputPaddingWrapper data-testid={testLabel}>
      <LabelCol xs={24} md={6} style={style}>
        <Label bold dark>
          {description}
        </Label>
      </LabelCol>
      <ContentCol xs={24} md={18}>
        {displayContent}
      </ContentCol>
    </InputPaddingWrapper>
  );
};

export default RenderInGrid;
